import React, { useState } from "react";
import { connect } from "react-redux";
import ChatHistory from "../../Extras/ChatHistory";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { selectAuthState } from "../../store/selectors/authSelectors";

function HelpPanel(props) {
  useState({
    voiceToText: false,
    imagesToPDF: false,
    documentRedaction: false,
    documentSearch: false,
  });

  return (
    <div
      className="assistant-sidebar-container"
      style={{
        width: props.expanded
          ? props.helpPanelExpandedWidth
          : props.helpPanelCollapsedWidth,
        transition: `width ${props.helpPanelTransitionTime}s`,
      }}
    >
      {!props.expanded ? (
        <>
          <div
            className="help-panel-arrow-container"
            onClick={() => {
              props.setExpanded(true);
            }}
          >
            <ArrowLeft className="help-panel-arrow-left" />
          </div>
        </>
      ) : (
        <>
          {props.expanded && (
            <div
              className="help-panel-arrow-container"
              onClick={() => {
                props.setExpanded(false);
              }}
            >
              <ArrowRight className="help-panel-arrow-right" />
            </div>
          )}
          <ChatHistory />
        </>
      )}
    </div>
  );
}

export default connect(selectAuthState)(HelpPanel);
